<template>
  <page>
    <div>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="newMode">mdi-plus</v-icon>
          <v-icon v-else-if="reviewMode">mdi-pencil</v-icon>
          <v-icon v-else-if="queryMode">mdi-magnify</v-icon>
          <v-toolbar-title v-if="newMode">Create Voluntary Cession Limit</v-toolbar-title>
          <v-toolbar-title v-else-if="reviewMode">Edit Voluntary Cession Limit</v-toolbar-title>
          <v-toolbar-title v-else-if="queryMode">View Voluntary Cession Limit</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex lg6 md6 xs12 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.branch }}</v-subheader>
                <div class="queryValue">{{ form.branch }}</div>
              </v-flex>
              <v-flex xs6 md6 lg6 v-else>
                <v-autocomplete
                  :items="branchList"
                  :label="labels.branch"
                  v-model="form.branch"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('form.branch')"
                  data-vv-name="form.branch"
                  :data-vv-as="labels.branch"
                  :disabled="reviewMode"
                  clearable
                >
                  <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                    <v-icon color="info" @click="getHelpList('branch')" v-text="'mdi-magnify'" :disabled="reviewMode"></v-icon>
                  </v-slide-x-reverse-transition>
                </v-autocomplete>
              </v-flex>
              <v-flex lg6 md6 xs12 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.busCls }}</v-subheader>
                <div class="queryValue">{{ form.busCls }}</div>
              </v-flex>
              <v-flex xs6 md6 lg6 v-else>
                <v-autocomplete
                  :items="buscls"
                  :label="labels.busCls"
                  v-model="form.busCls"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('form.busCls')"
                  data-vv-name="form.busCls"
                  :data-vv-as="labels.busCls"
                  v-validate="'required'"
                  :disabled="reviewMode"
                  clearable
                >
                  <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                    <v-icon color="info" @click="getHelpList('busCls')" v-text="'mdi-magnify'" :disabled="reviewMode"></v-icon>
                  </v-slide-x-reverse-transition>
                </v-autocomplete>
              </v-flex>
              <v-flex lg6 md6 xs12 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.polSILim }}</v-subheader>
                <div class="queryValue">{{ form.polSILim }}</div>
              </v-flex>
              <v-flex lg6 md6 xs12 v-else>
                <v-text-field
                  v-model="form.polSILimDisp"
                  :label="labels.polSILim"
                  v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                  :error-messages="errors.collect('polSILimDisp')"
                  data-vv-name="polSILimDisp"
                  :data-vv-as="labels.polSILim"
                  v-validate="'required|mask_decimal:4|mask_min_value:0'"
                  :disabled="reviewMode"
                ></v-text-field>
              </v-flex>
              <v-flex lg6 md6 xs12 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.expDate }}</v-subheader>
                <div class="queryValue">{{ form.expDate }}</div>
              </v-flex>
              <v-flex lg6 md6 xs12 v-else>
                <cal-picker
                  :label="labels.expDate"
                  v-model="form.expDate"
                  :error-messages="errors.collect('expDate')"
                  data-vv-name="expDate"
                  :data-vv-as="labels.expDate"
                  v-validate="'required'"
                  :disabled="reviewMode"
                ></cal-picker>
              </v-flex>
              <v-flex lg6 md6 xs12 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.cesSILim }}</v-subheader>
                <div class="queryValue">{{ form.cesSILim }}</div>
              </v-flex>
              <v-flex lg6 md6 xs12 v-else>
                <v-text-field
                  v-model="form.cesSILimDisp"
                  :label="labels.cesSILim"
                  v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                  :error-messages="errors.collect('cesSILimDisp')"
                  data-vv-name="cesSILimDisp"
                  :data-vv-as="labels.cesSILim"
                  v-validate="'required|mask_decimal:2|mask_min_value:0'"
                ></v-text-field>
              </v-flex>
              <v-flex lg6 md6 xs12 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.cesSIPct }}</v-subheader>
                <div class="queryValue">{{ form.cesSIPct }}</div>
              </v-flex>
              <v-flex lg6 md6 xs12 v-else>
                <v-text-field
                  v-model="form.cesSIPct"
                  :label="labels.cesSIPct"
                  v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                  :error-messages="errors.collect('cesSIPct')"
                  data-vv-name="cesSIPct"
                  :data-vv-as="labels.cesSIPct"
                  v-validate="'required|mask_decimal:2|mask_min_value:0|mask_max_value:100'"
                ></v-text-field>
              </v-flex>
              <v-flex v-if="queryMode">
                <v-checkbox readonly v-model="form.acqApp" :label="labels.acqApp"></v-checkbox>
              </v-flex>
              <v-flex v-else>
                <v-checkbox
                  v-model="form.acqApp"
                  :label="labels.acqApp"
                  :error-messages="errors.collect('acqApp')"
                  data-vv-name="acqApp"
                  :data-vv-as="labels.acqApp"
                  v-validate="'required'"
                ></v-checkbox>
              </v-flex>
              <v-flex v-if="queryMode">
                <v-checkbox readonly v-model="form.defComm1AE" :label="labels.defComm1AE"></v-checkbox>
              </v-flex>
              <v-flex v-else>
                <v-checkbox
                  v-model="form.defComm1AE"
                  :label="labels.defComm1AE"
                  :error-messages="errors.collect('defComm1AE')"
                  data-vv-name="defComm1AE"
                  :data-vv-as="labels.defComm1AE"
                  v-validate="'required'"
                ></v-checkbox>
              </v-flex>
              <v-flex v-if="queryMode">
                <v-checkbox readonly v-model="form.defComm2AE" :label="labels.defComm2AE"></v-checkbox>
              </v-flex>
              <v-flex v-else>
                <v-checkbox
                  v-model="form.defComm2AE"
                  :label="labels.defComm2AE"
                  :error-messages="errors.collect('defComm2AE')"
                  data-vv-name="defComm2AE"
                  :data-vv-as="labels.defComm2AE"
                  v-validate="'required'"
                ></v-checkbox>
              </v-flex>
              <v-flex xs5 md5 lg5>
                <v-autocomplete
                  v-model="form.comm2Gn"
                  v-validate="'required'"
                  :items="grossNetList"
                  :label="labels.comm2Gn"
                  item-text="label"
                  item-value="value"
                  data-vv-name="comm2Gn"
                  :error-messages="errors.collect('comm2Gn')"
                  :data-vv-as="labels.comm2Gn"
                  :disabled="queryMode"
                ></v-autocomplete>
              </v-flex>
              <v-flex lg6 md6 xs12 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.comm2Pct }}</v-subheader>
                <div class="queryValue">{{ form.comm2Pct }}</div>
              </v-flex>
              <v-flex lg6 md6 xs12 v-else>
                <v-text-field
                  v-model="form.comm2Pct"
                  :label="labels.comm2Pct"
                  :error-messages="errors.collect('comm2Pct')"
                  data-vv-name="comm2Pct"
                  :data-vv-as="labels.comm2Pct"
                  v-validate="'required|mask_decimal:4|mask_min_value:0|mask_max_value:100'"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ form.createdBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ form.createdDate | formatDate }}</div>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs6 v-if="!newMode">
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ form.modifiedBy }}</div>
              </v-flex>
              <v-flex xs6 v-if="!newMode">
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ form.modifiedDate | formatDate }}</div>
              </v-flex>
              <v-flex>
                <v-spacer class="mt-3"></v-spacer>
                <v-btn color="error" dark class=" mr-2" @click.prevent="doCancel">Cancel<v-icon dark right>mdi-cancel</v-icon></v-btn>
                <v-btn color="primary" dark class=" mr-2" @click="doSave" :loading="submitting">
                  Save
                  <v-icon right>mdi-content-save </v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
      <!-- Helplist -->
      <v-dialog v-model="showBranchHelpList" width="1280px">
        <branch-help-list @close="showBranchHelpList = false" @assign-branch="assignBranch"></branch-help-list>
      </v-dialog>
      <v-dialog v-model="showBusClsHelpList" width="1280px">
        <busCls-help-list @close="showBusClsHelpList = false" @assign-busCls="assignBusCls"></busCls-help-list>
      </v-dialog>
    </div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { commonMixins } from '@/mixins/common/commonMixin'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import BranchHelpList from '@/components/core/common/dialog/BranchHelpList'
import BusClsHelpList from '@/components/core/common/dialog/BusClsHelpList'
import { formatDisplayNumber, removeFormatNumber } from '@/utils/number'
import { formatDisplayDate, formatDisplayDateTime2, removeTime } from '@/utils/date'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      submitting: false,
      newMode: true,
      queryMode: false,
      reviewMode: false,
      showBranchHelpList: false,
      showBusClsHelpList: false,
      labels: {
        branch: 'Branch',
        branchDesc: 'Branch Description',
        busCls: 'Business Class',
        busClsDesc: 'Business Class Description',
        polSILim: 'Policy Sum Insured Limit',
        expDate: 'Expiry Date',
        cesSILim: 'Cession Sum Insured Limit',
        cesSIPct: 'Cession Sum Insured %',
        acqApp: 'Acquisition Applicable',
        defComm1AE: 'Default Commission 1 A/E',
        defComm2AE: 'Default Commission 2 A/E',
        comm2Gn: 'Commission 2 Gross/Net',
        comm2Pct: 'Commission 2 %',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      form: {
        branch: '',
        branchDesc: undefined,
        busCls: undefined,
        busClsDesc: undefined,
        polSILim: 0,
        polSILimDisp: undefined,
        expDate: new Date(),
        expDateDisp: undefined,
        cesSILim: 0,
        cesSILimDisp: undefined,
        cesSIPct: 0,
        acqApp: true,
        defComm1AE: false,
        defComm2AE: false,
        comm2Gn: 'N',
        comm2Pct: 0,
        createdBy: null,
        createdDate: new Date(),
        modifiedBy: null,
        modifiedDate: null
      },
      branchList: [],
      buscls: []
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      this.getCommonDataListDropDown('branchList')
      this.getCommonDataListDropDown('buscls')
      if (this.mode === 'Review') {
        this.newMode = false
        this.reviewMode = true
        this.queryMode = false
        this.fetchData()
      } else if (this.mode === 'Query') {
        this.newMode = false
        this.reviewMode = false
        this.queryMode = true
        this.fetchData()
      } else if (this.mode === 'New') {
        this.newMode = true
        this.reviewMode = false
        this.queryMode = false
      } else {
        this.doCancel()
      }
    },
    getHelpList(fieldname) {
      this.helplist = true
      if (fieldname === 'branch') {
        this.showBranchHelpList = true
        this.showBusClsHelpList = false
      } else if (fieldname === 'busCls') {
        this.showBranchHelpList = false
        this.showBusClsHelpList = true
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newMode) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doCancel() {
      this.$router.push({ name: 'volCesLimList' })
    },
    async doCreate() {
      const apiURI = this.menu.createVolCesLim
      if (apiURI) {
        this.form.polSILim = parseInt(removeFormatNumber(this.form.polSILimDisp))
        this.form.cesSILim = parseInt(removeFormatNumber(this.form.cesSILimDisp))
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.message(data)
            this.fieldMessage(data)
            this.doCancel()
          }
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.menu.updateVolCesLim
      if (apiURI) {
        this.form.polSILim = parseInt(removeFormatNumber(this.form.polSILimDisp))
        this.form.cesSILim = parseInt(removeFormatNumber(this.form.cesSILimDisp))
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.message(data)
            this.fieldMessage(data)
            this.doCancel()
          }
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    assignBranch(branch) {
      this.form.branch = branch
      this.showBranchHelpList = false
    },
    assignBusCls(busCls) {
      this.form.busCls = busCls.busCls
      this.showBusClsHelpList = false
    },
    async fetchData() {
      const apiURI = this.menu.getVolCesLim
      if (apiURI) {
        try {
          const expand = {
            branch: this.volCesLimParam.branch,
            busCls: this.volCesLimParam.busCls,
            expDate: formatDisplayDateTime2(removeTime(this.volCesLimParam.expDate)),
            polSILim: this.volCesLimParam.polSILim
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.form.branch = data.volCesLim.branch
            this.form.branchDesc = data.volCesLim.branchDesc
            this.form.busCls = data.volCesLim.busCls
            this.form.busClsDesc = data.volCesLim.busClsDesc
            this.form.expDate = data.volCesLim.expDate
            this.form.expDateDisp = formatDisplayDate(data.volCesLim.expDate)
            this.form.polSILim = data.volCesLim.polSILim
            this.form.polSILimDisp = formatDisplayNumber(data.volCesLim.polSILim)
            this.form.cesSILim = data.volCesLim.cesSILim
            this.form.cesSILimDisp = formatDisplayNumber(data.volCesLim.cesSILim)
            // this.form.cesSIPct = data.volCesLim.cesSIPct
            this.form.cesSIPct = formatDisplayNumber(data.volCesLim.cesSIPct)
            this.form.acqApp = data.volCesLim.acqApp
            this.form.comm2Pct = formatDisplayNumber(data.volCesLim.comm2Pct)
            this.form.comm2Gn = data.volCesLim.comm2GnCode
            this.form.defComm1AE = data.volCesLim.defComm1AE
            this.form.defComm2AE = data.volCesLim.defComm2AE
            this.form.createdBy = data.createdBy
            this.form.createdDate = data.volCesLim.createdDate
            this.form.modifiedBy = data.modifiedBy
            this.form.modifiedDate = data.volCesLim.modifiedDate
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    formatDisplayNumber(xNum, scale) {
      return formatDisplayNumber(xNum, scale)
    },
    removeFormatNumber(value) {
      return removeFormatNumber(value)
    }
  },
  created() {
    this.doInit()
    this.form.createdBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
    this.form.createdDate = new Date()
  },
  computed: {
    menu() {
      return this.$store.state.volCesLimParam.menu
    },
    mode() {
      return this.$route.params.tranMode
    },
    volCesLimParam() {
      return this.$route.params.volCesLimParam
    }
  },
  filters: {
    formatDate(value) {
      return formatDisplayDate(value)
    }
  },
  mixins: [MessageMixin, commonMixins, commonAjaxMixin],
  components: {
    BranchHelpList,
    BusClsHelpList
  }
}
</script>
